import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("evaluatedCode"),
            field: 'evaluatedCode',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("evaluatedFullName"),
            field: 'evaluatedName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("evaluationStatus"),
            field: 'status',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("year"),
            field: 'year',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("processPeriod"),
            field: 'period',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("noteStatus"),
            field: 'noteStatus',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("note2"),
            field: 'note',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "ProgressByRankingRendererDynamicColor",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("noteName"),
            field: 'noteName',
            filter: "agSetColumnFilter",
        }
    },
    {
            pages: [paths.performanceSummaryAndResults],
            config: {
                headerName: getLocalizedString("pointsAssigned"),
                field: 'pointsAssigned',
                filter: "agTextColumnFilter",
                comparator: numberComparatorMax2,
                filterParams: numberFilterParams(),
                chartDataType: "series",
                cellClass: "currencyValue",
                valueFormatter: createNumberFormatter(0, 1),
                enableValue: true,
                allowedAggFuncs: ["sum", "min", "max", "avg"],
            }
        },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("ranking"),
            field: 'ranking',
            cellRenderer: "ProgressRenderer",
            filter: "ProgressFilter",
            cellClass: "percentageValue",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("feedbackDelivered"),
            field: 'feedback',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("feedbackDate"),
            field: 'feedbackDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("feedbackResponsible"),
            field: 'feedbackResponsible',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("acceptedByEvaluator"),
            field: 'evaluatedAcceptation',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("evaluatedComments"),
            field: 'evaluatedComments',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("management"),
            field: "management",
            filter: "agSetColumnFilter",
        }
    },

    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "costCenter",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceSummaryAndResults],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "division",
            filter: "agSetColumnFilter",
        }
    },
]